const ROUTE_PARAMS = {
    CONNECTION_TYPE: 'connectionType',
};

export default ROUTE_PARAMS;
